import React from 'react';
import { useSelector } from 'react-redux';
import { Card } from "@mui/material";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { makeStyles } from '@mui/styles';
import { selectUserInfo } from '../../../features/userInfo/userInfoSlice';
import colors from '../../colors';
import { texts } from '../../general/texts';
import { useNavigate } from 'react-router-dom';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

const DashboardSection = ({onRemoveSection}) => {

    const userInfo = useSelector(selectUserInfo)
    const isSmallScreen = useMediaQuery('(max-width:900px)')
    const navigate = useNavigate()

    const removeSection = () => {
        localStorage.setItem('removeIFSection', JSON.stringify(true));
        if (onRemoveSection) {
            onRemoveSection(); 
        }
    };

    const useStyles = makeStyles({
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        card: {
            borderRadius: '20px',
            marginTop: '40px',
            width: '60%',
            height: '125px',
            boxShadow: '0 0 15px 5px #E5E7EA',
            display: 'flex',
            flexDirection: 'column',
            // alignItems: 'center',
            marginRight: isSmallScreen ? '5vw' : 0,
            '@media (max-width: 1440px)': { width: '80%' },
            '@media (max-width: 899px)': { width: '90%' }
        },
        customButton: {
            color: colors.white,
            background: colors.darkBlue,
            border: 'none',
            borderRadius: '20px',
            width: '120px',
            height: '25px',
            fontSize: '13px',
            fontFamily: 'GerberaMedium',
            alignSelf: 'center',
            cursor: 'pointer',
            marginTop: isSmallScreen? '10px' : '15px',
            '&:hover': {
                background: colors.gradientOrange,
            }
        }
    });
    const classes = useStyles();

    return (
        <>
            <Card className={classes.card}>
                <HighlightOffIcon color='warning' style={{alignSelf: 'end', marginTop: 4, marginRight: 4, cursor: 'pointer'}} onClick={removeSection}/>
                <span style={{ fontSize: '20px', fontFamily: 'GerberaBold', color: colors.orange, marginTop: '-10px' }}>{(userInfo.isUserInvited && !userInfo.canUserGenerateCode) ? texts['title-win-500All'] : texts['title-500All']}</span>
                <span style={{ fontSize: '15px', fontFamily: 'GerberaMedium', color: colors.darkBlue }}>{(userInfo.isUserInvited && !userInfo.canUserGenerateCode) ? texts['IaF-dashboard-refered'] : texts['IaF-dashboard']}</span>
                <button onClick={() => navigate('/inviteFriend')} className={classes.customButton}>{texts['prompt-more']}</button>
            </Card>
        </>
    );
};

export default DashboardSection;